import mixpanel from "mixpanel-browser";
import { getLocalStorage } from "../helpers/storage";

const token = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;

if (process.env.REACT_APP_NODE_ENV === "production") {
  if (!token) {
    throw new Error(
      "Mixpanel token is not defined. Please set REACT_APP_MIXPANEL_PROJECT_TOKEN in your environment variables.",
    );
  }
  mixpanel.init(token);
}
export enum Devices {
  MOBILE = "mobile",
  TABLET = "tablet",
  DESKTOP = "desktop",
}

export enum MixpanelEvent {
  EPISODE_WATCHED = "EPISODE_WATCHED",
  CARD_CLICK = "CARD_CLICK",
  BUTTON_PRESSED = "BUTTON_PRESSED",
  ACADEMY_TAB_PRESS = "ACADEMY_TAB_PRESS",
  ONBOARDING_LOC_PERM_MODAL_VIEW = "ONBOARDING_LOC_PERM_MODAL_VIEW",
  ONBOARDING_LOC_PERM_MODAL_DISMISS = "ONBOARDING_LOC_PERM_MODAL_DISMISS",
  ONBOARDING_LOC_PERM_MODAL_ALLOW = "ONBOARDING_LOC_PERM_MODAL_ALLOW",
  ONBOARDING_LINKEDIN_SUBMIT = "ONBOARDING_LINKEDIN_SUBMIT",
  ONBOARDING_LINKEDIN_SKIP = "ONBOARDING_LINKEDIN_SKIP",
  TOOLS_DOWNLOAD_PRESS = "TOOLS_DOWNLOAD_PRESS",
  PAGE_VIEW = "PAGE_VIEW",
  OTP_VERIFICATION_SUBMITTED = "OTP_VERIFICATION_SUBMITTED",
}

export const getUserIdFromLocalStorage = (): string | undefined => {
  const userData = JSON.parse(getLocalStorage("userData") || "{}");
  return userData._id;
};

export const trackEvent = (
  eventName: string,
  payload: Record<string, unknown>,
): void => {
  const userId = getUserIdFromLocalStorage();
  if (userId) {
    payload["$user_id"] = userId;
  }
  payload.device = getDeviceInfo();
  payload.user_agent = navigator.userAgent;
  if (process.env.REACT_APP_NODE_ENV === "production") {
    mixpanel.track(eventName, payload);
  }
};

export const identifyUser = (
  userId: string,
  userProps?: Record<string, any>,
) => {
  mixpanel.identify(userId);
  if (userProps) {
    mixpanel.people.set(userProps);
  }
};

export const resetUser = () => {
  mixpanel.reset();
};

const getDeviceInfo = (): Devices => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/mobile/.test(userAgent)) {
    return Devices.MOBILE;
  } else if (/tablet/.test(userAgent)) {
    return Devices.TABLET;
  } else {
    return Devices.DESKTOP;
  }
};
